<template>
  <div class="px-2 px-sm-4">
    <!-- Botón Volver -->
    <div class="back-button-wrapper">
      <v-btn class="back-btn" @click="goBack" text small>
        <v-icon left small>mdi-arrow-left</v-icon>
        Volver
      </v-btn>
    </div>

    <!-- Título Responsive -->
    <h2 class="text-h5 text-sm-h4 font-weight-bold white--text mb-3 mb-sm-4">
      Promociones Activas
    </h2>

    <!-- Grid Adaptativo -->
    <v-row dense justify="center" class="mx-0">
      <v-col
        v-for="promo in promos"
        :key="promo.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        class="pa-2 pa-sm-3"
      >
        <div
          class="promo-container hoverable"
          :style="{ backgroundImage: 'url(' + promo.image + ')' }"
          @click="openPromo(promo)"
          :aria-label="'Promoción: ' + promo.title"
          role="button"
        >
          <div class="promo-title-overlay">
            {{ promo.title }}
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Diálogo Modal -->
    <v-dialog v-model="dialog.visible" max-width="960px" scrollable>
      <v-card>
        <v-card-title class="headline">{{ dialog.title }}</v-card-title>
        <v-card-text class="dialog-content">
          <div v-html="dialog.content"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red darken-1" text @click="dialog.visible = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PromotionsGrid",
  data() {
    return {
      promos: [
        {
          id: "dividendos",
          title: "Escala de Dividendos",
          image: "https://trackandraces.com/dominio/tr/menu/dividendos.png",
          file: "/promos/dividendos.html",
        },
        {
          id: "referido",
          title: "Gana por Cada Referido",
          image: "https://trackandraces.com/dominio/tr/menu/referidos.png",
          file: "/promos/referido.html",
        },
        {
          id: "primerdeposito",
          title: "30% Primer Depósito",
          image: "https://trackandraces.com/dominio/tr/menu/primerdeposito.png",
          file: "/promos/primerdeposito.html",
        },
        {
          id: "goldenticket",
          title: "Golden Ticket",
          image: "https://trackandraces.com/dominio/tr/menu/goldenticket.png",
          file: "/promos/golden_ticket.html",
        },
        {
          id: "registro",
          title: "10 Free Spin Con Registro",
          image: "https://trackandraces.com/dominio/tr/menu/registro.png",
          file: "/promos/registro10fsp.html",
        },
        {
          id: "DepositosFS",
          title: "10FS Con tu Primer Depósito",
          image: "https://trackandraces.com/dominio/tr/menu/fsdeposito.png",
          file: "/promos/deposito10fsp.html",
        },
      ],
      dialog: {
        visible: false,
        title: "",
        content: "",
      },
    };
  },
  methods: {
    async openPromo(promo) {
      try {
        const response = await fetch(promo.file);
        if (!response.ok) throw new Error("Error al cargar");
        const html = await response.text();
        this.dialog = {
          visible: true,
          title: promo.title,
          content: html,
        };
      } catch (error) {
        this.dialog = {
          visible: true,
          title: "Error",
          content: `<p class="error-message">No se pudo cargar la promoción. Intente nuevamente.</p>`,
        };
        console.error("Error loading promo:", error);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
/* Sistema Grid Responsive */
.promo-container {
  width: 100%;
  aspect-ratio: 4/2.6;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Overlay de Título Adaptativo */
.promo-title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
  color: white;
  font-weight: 700;
  text-align: center;
  padding: 8px;
  font-size: 0.75rem;
  line-height: 1.3;
  pointer-events: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* Efecto Hover Optimizado */
.hoverable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Diálogo Modal */
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px 24px;
}
.dialog-content >>> .error-message {
  color: #d32f2f;
  text-align: center;
}

/* Botón Volver */
.back-button-wrapper {
  padding: 8px 0;
}
.back-btn {
  color: #fff !important;
  letter-spacing: normal;
}

/* Media Queries para Dispositivos Específicos */
@media (min-width: 600px) {
  .promo-container {
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  .promo-title-overlay {
    font-size: 0.875rem;
    padding: 10px;
  }
}

@media (min-width: 960px) {
  .promo-container {
    border-radius: 12px;
  }
  .promo-title-overlay {
    font-size: 1rem;
    padding: 12px 10px;
  }
  .hoverable:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
}

@media (min-width: 1264px) {
  .promo-title-overlay {
    font-size: 1.125rem;
  }
}

/* Ajustes para móviles pequeños */
@media (max-width: 400px) {
  .promo-title-overlay {
    font-size: 0.6875rem;
    padding: 6px 4px;
  }
}
</style>